import { NgModule } from '@angular/core';

import { SharedModule } from 'ish-shared/shared.module';

import { SalesRepCustomerSwitchConfirmationModalComponent } from './shared/customer-switch-confirmation-modal/sales-rep-switch-confirmation-modal.component';
import { SalesRepUsersListComponent } from './shared/sales-rep-users-list/sales-rep-users-list.component';

@NgModule({
  imports: [SharedModule],
  declarations: [SalesRepCustomerSwitchConfirmationModalComponent, SalesRepUsersListComponent],
  exports: [SharedModule],
})
export class SalesRepModule {}
